import * as yup from 'yup';

export const getDefaultPinValidationValues = (initialData) => ({
  code: '',
  email: '',
  // email: 'felix.prieto@dox.cl',
  ...initialData,
});

const PinValidationSchema = yup
  .object({
    code: yup
      .string()
      .test('len', 'La longitud es de 5 caracteres', (val) => {
        if (val === undefined) {
          return true;
        }
        return new RegExp(/^\w{5}$/).test(val);
      })
      .required('Requerido'),
    email: yup
      .string()
      .required('Requerido.')
      .email('Debe ser un correo electrónico válido.'),
  })
  .required();

export default PinValidationSchema;
